import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { fetchEventImage, fetchOngoingEvents, fetchUpcomingEvents, fetchUsers } from "../redux/slices/userSlice";
import ClipLoader from "react-spinners/ClipLoader";
import { toast } from "react-toastify";

const PAGE_SIZE = 20;

const EventRap = styled.div`
  background: #ffffff;
  border-radius: 20px;
  border: 1px solid #bac0d499;
  padding: 50px;
  
width: 100%;
  @media (max-width: 1400px) {
    padding: 20px;
  }
  @media (max-width: 1330px) {
    padding: 10px;
  }

  .events-sub-1 h4 {
    color: #060b13;
    font-size: 20px;
    font-weight: 600;
  }
  .events-1 button {
    color: #ed1c24 !important;
    border-top: 1px;
    border-right: 4px;
    border-bottom: 4px;
    border-left: 1px;
    border-style: solid;
    border-color:  #ed1c24 !important;
    font-size: 16px;
    font-weight: 600 !important;
    height: 40px;
    width: fit-content;
    padding: 10px;
    border-radius: 100px;
  }
  .events-sub-1 p {
    color: #363d4f;
    font-size: 15px;
    font-weight: 400;
  }
  .events-1 button {
    border-top: 1px;
    border-right: 4px;
    border-bottom: 4px;
    border-left: 1px;
    border-style: solid;
    width: 213px;
    height: 45px;
    color: #060b13;
    font-size: 14px;
    font-weight: 500;
    border-radius: 100px;
    border-color: #060b13;
  }
  .events-1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }
  .search-div-input {
    width: 268px;
    position: relative;
  }
  .search-icon {
    position: absolute;
    left: 10px;
    top: 13px;
  }
  .search-div-input input {
    border: 0.64px solid #bac0d4b2;
    padding-left: 30px;
    width: 268px;
    height: 40px;
    border-radius: 100px;
  }
  .filter-div p {
    color: #344054;
    font-weight: 400;
    font-size: 14px;
  }
  .filter-div {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0.64px solid #bac0d4b2;
    width: 92px;
    height: 40px;
    gap: 10px;
    cursor: pointer;
    border-radius: 100px;
  }
  .filter-drop-down {
    box-shadow: 0px 8px 22px 0px #2230491A;
    border: 0.6px solid #D0D5DD;
    background: #FFFFFF;
    width: 175px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 10;
    right: 0px;
   
    position: absolute;
  }
  .filter-drop-down p {
    color: #060B13;
    padding: 5px;
    font-weight: 400;
    font-size: 14px;

  }
  .filter-drop-down p:hover {
    background: #E8E9EB;
    border-radius: 6px;
  }
  .event-sub-2 {
    display: flex;
    gap: 20px;
  }
  .events-divs-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-top: 30px;
  }
  .pagination-controls {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    margin-top: 20px;
  }
  .pagination-controls button {
    padding: 8px 16px;
    border-radius: 999px;
    border: 1px solid #bac0d4;
    background: #ffffff;
    color: #060b13;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
  }
  .pagination-controls button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .pagination-controls span {
    font-size: 14px;
    color: #363d4f;
    font-weight: 500;
  }
  .events-text-divs {
    padding: 20px;
    border-radius: 5px;
    height: 246px;

    width: 320px;

    gap: 10px;
    cursor: pointer;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .push-down-event {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  .events-text-divs h4 {
    font-size: 12px;
    font-weight: 600;
    color: #ffffff;
    line-height: 17px;
    max-width: 183px;
  }
  .events-text-divs p {
    color: #dcdcdc;
    font-size: 12px;
    font-weight: 400;
  }
  .down-event-text {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .events-2 {
    border: 0.7px solid #bac0d499;
    border-radius: 20px;
    padding: 24px 32px;
    margin-top: 30px;
  }
  .down-event-text-div {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  .the-play-audion-icon {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 80%;
  }
  .event-round {
    width: 42px;
    border-radius: 50%;
    height: 42px;
  }
  .timezone p {
    color: #828286;
    font-size: 12px;
    font-weight: 400;
  }
  .timezone p a {
    text-decoration: none;
    color: #ed1c24;
  }
  .timezone {
    position: relative;
  }
  .timezone-dropdown {
    padding: 0;
    border: 1px solid #ddd;
    border-radius: 15px;
    width: 300px;
    background: #ffffff;
    position: absolute;
    z-index: 9999;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  .time-input,
  .calendar-container input {
    width: 210px;
    height: 50px;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 15px;
    border: 0.8px solid #bac0d4b2;

    font-weight: 400;
    font-size: 12px;
  }
  .time-dropdown {
    border: 0.6px solid #d0d5dd;
    box-shadow: 0px 8px 22px 0px #2230491a;
    width: 207px;
    background: #ffffff;
    padding: 20px;
    margin-top: 10px;
    padding-right: 10px;
    border-radius: 10px;
    position: absolute;
    z-index: 1000;
  }
  .time-dropdown p {
    color: #060b13;
    font-weight: 400;
    text-align: center;
    font-size: 12px;
  }
  .time-dropdown-div {
    max-height: 240px;
    overflow-y: scroll;
    padding: 5px 10px;
  }
  .time-dropdown-div::-webkit-scrollbar {
    width: 6px;
  }

  .time-dropdown-div::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  .time-dropdown-div::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .time-dropdown-div::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  .time-dropdown-div::-webkit-scrollbar-button {
    display: none;
  }
  .the-time {
    padding: 10px;
    cursor: pointer;
    border-radius: 6px;
    color: #060b13;
    font-weight: 500;
    font-size: 12px;
  }
  .time-cancel {
    border: none;
    color: #060b13;
    font-size: 14px;
    font-weight: 400;
    background: #ffffff;
  }
  .time-save {
    background: #ed1c24;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
    border: none;
    width: 66px;
    height: 32px;
    border-radius: 8px;
  }
  .calendar-container {
    position: relative;
    max-width: 344px;
  }

  .calendar-dropdown {
    position: absolute;
    top: 50px;
      right: 20%;
    background: white;
    border: 0.6px solid #d0d5dd;
    border-radius: 10px;
    padding: 15px;
    margin-top: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    max-width: 344px;
    z-index: 10;
  }

  .calendar-header {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 10px;
    color: #1e1e1c;
    font-size: 14px;
    font-weight: 400;
  }

  .calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px;
  }

  .calendar-day {
    padding: 10px;
    text-align: center;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    color: #1e1e1c;
    font-weight: 400;
  }

  .today {
    color: #ed1c24;
  }

  .selected {
    background: #ed1c24;
    color: white;
    border-radius: 50%;
  }

  .other-month {
    color: #828280;
  }
  .start-date-time {
    display: flex;
    gap: 10px;
  }
  .category-input {
    width: 430px;
    height: 50px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 0px;
    border-radius: 100px;
    border: 0.8px solid #bac0d4b2;
  }
  .category-input p {
    color: #060b13;
    font-weight: 400;
    font-size: 14px;
    padding: 0px 15px;
  }
  .category {
    position: relative;
  }
  .category-dropdown {
    border: 0.6px solid #d0d5dd;
    box-shadow: 0px 8px 22px 0px #2230491a;
    background: #ffffff;
    width: 430px;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    gap: 15px;
    padding: 10px;
    z-index: 9999;
    position: absolute;
    margin-top: 10px;
  }
  .category-dropdown p {
    color: #060b13;
    font-weight: 400;
    font-size: 14px;
    padding: 10px;
  }
  .category-dropdown p:hover {
    background: #e8e9eb;
    border-radius: 6px;
  }
  input {
    border: 0.8px solid #bac0d4b2;
    width: 430px;
    height: 50px;
    border-radius: 100px;
    color: #060b13;
    font-weight: 400;
    font-size: 14px;
    padding-left: 15px;
  }
  .custom-radio {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #060b13;
  }

  .custom-radio input[type="radio"] {
    display: none; /* Hide default radio button */
  }

  .radio-checkmark {
    height: 20px;
    width: 20px;
    border: 2px solid red;
    border-radius: 50%;
    margin-right: 10px;

    position: relative;
  }

  .custom-radio input[type="radio"]:checked + .radio-checkmark {
    background-color: transparent;
  }

  .custom-radio input[type="radio"]:checked + .radio-checkmark:before {
    content: "";
    position: absolute;
    top: 3px;
    left: 3px;
    height: 10px;
    width: 10px;
    background-color: red;
    border-radius: 50%;
  }

  .upload-img-div {
    display: inline-block;
    padding: 8px 16px;
    background: #e8e9eb;

    color: #060b13 !important;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 400;
  }
  .fileInput {
    display: none;
  }
  .tap-to-upload h6 {
    font-size: 14px;
    color: #171717;
    font-weight: 500;
  }
  .file-upload {
    width: 201px;
    height: 83px;

    justify-content: center;
    display: flex;
    gap: 16px;
    border-radius: 15px;
    align-items: center;
    border: 0.8px solid #bac0d4b2;
  }
  .tap-to-upload p {
    font-size: 12px;
    color: #9499ac;
    font-family: "Inter";
  }
  .uploadedImage {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .uploadedImage p {
    font-weight: 400;
    max-width: 201px;
    font-size: 12px;
    color: #828286;
  }
  .uploadedImage-default {
    max-width: 201px;
    height: 83px;
    border-radius: 5px;
  }
  .add-uploaded-divs {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }
  .all-dropdown-div {
    max-width: 500px;
    max-height: 546px;
    background: #ffffff;
    border-radius: 16px;
  }
  .schedule-btn {
    border-top: 1px;
    border-right: 4px;
    border-bottom: 4px;
    border-left: 1px;
    border-style: solid;
    width: 430px !important;
    height: 50px !important;
    border-radius: 100px;
    padding: 12px;
    background: #ed1c24;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    border-color: #060b13;
  }
  .schedule-btn {
    border-top: 1px;
    border-right: 4px;
    border-bottom: 4px;
    border-left: 1px;
    border-style: solid;
    width: 430px;
    height: 50px;
    border-radius: 100px;
    background: #ed1c24;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    border-color: #060b13;
  }
  .audio-icon-div {
    background: #e4e5e7;
    width: 28px;
    border-radius: 50%;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .audio-icon-div img {
    height: 16px;
    width: 19px !important;
  }
  .recording-upload-dic {
    height: 120px;
    max-width: 430px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border-radius: 15px;
    border: 0.7px solid #bac0d4b2;
    padding: 20px;
  }
  .click-upload {
    color: #828286;
    font-size: 12px;
    font-weight: 400;
  }
  .click-upload span {
    color: #ed1c24;
    font-weight: 600;
  }
  .the-upload-input {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
  .link-container {
    display: flex;
    gap: 15px;
  }
  .link {
    text-decoration: none;
    color: #818893;
    font-size: 14px;
    font-weight: 500;
    padding-bottom: 10px;
  }
  .link.active {
    color: #060b13;
    border-bottom: 3px solid #000000;
  }
  .link-sub-event {
    display: flex;
    justify-content: space-between;
  }
  @media (max-width: 1300px) {
    .events-divs-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  @media (max-width: 650px)  {
.link-sub-event {
  flex-wrap: wrap;
  gap: 15px;
}
  }
  @media (max-width: 500px)  {
    .event-sub-2 {
      flex-wrap: wrap;
    }
  }
  @media (max-width: 750px) {
    .events-divs-grid {
      grid-template-columns: repeat(1, 1fr);
    }
  }
  @media (max-width: 400px) {
.events-text-divs {
  width: 290px !important;
  background-position: left;
}
.events-2 {
  padding: 24px 10px !important;

}
  }
`;

const ListenerEvents = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    ongoingEvents,
    upcomingEvents,
    loading,
    error,
    ongoingEventsLoading,
    eventImages = {},
  } = useSelector((state) => state.userData);

  const [showPopSchedule, setShowPopSchedule] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [uploadState, setUploadState] = useState("default");
  const [fileName, setFileName] = useState("");
  const [showAcess, setShowAccess] = useState(false);
  const [selectedAccess, setSelectedAccess] = useState("Access type");
  const [selectedOption, setSelectedOption] = useState("default");
  const [filterdrop, setFilterdrop] = useState(false);
  const [activeLink, setActiveLink] = useState("public");
  const [ongoingPage, setOngoingPage] = useState(1);
  const [upcomingPage, setUpcomingPage] = useState(1);

  const getEventsPayload = (events) =>
    events?.data || events?.events || events;

  const buildEventCards = (payload) => {
    if (!Array.isArray(payload) || payload.length === 0) {
      return [];
    }

    return payload.map((item) => {
      const id = item?.id || item?.eventId;
      const fallbackImage =
        item?.imageUrl && item.imageUrl.trim() !== ""
          ? item.imageUrl
          : item?.bgImage && item.bgImage.trim() !== ""
          ? item.bgImage
          : "/images/image_1.png";

      return {
        id,
        channelId: item?.channelId || item?.channel?.id,
        title: item?.title || item?.name || "Untitled event",
        text: item?.description || item?.summary || "",
        bgImage: eventImages?.[id] || fallbackImage,
        color: "#4A4A4A",
      };
    });
  };

  const liveEvents = useMemo(
    () => buildEventCards(getEventsPayload(ongoingEvents)),
    [eventImages, ongoingEvents]
  );

  const upcomingEventCards = useMemo(
    () => buildEventCards(getEventsPayload(upcomingEvents)),
    [eventImages, upcomingEvents]
  );

  useEffect(() => {
    const sources = [
      getEventsPayload(ongoingEvents),
      getEventsPayload(upcomingEvents),
    ];

    sources.forEach((payload) => {
      if (!Array.isArray(payload) || payload.length === 0) {
        return;
      }

      payload.forEach((item) => {
        const id = item?.id || item?.eventId;
        if (!id || eventImages?.[id]) {
          return;
        }

        dispatch(fetchEventImage(id));
      });
    });
  }, [dispatch, eventImages, ongoingEvents, upcomingEvents]);


  console.log(ongoingEvents);

  const following = useMemo(
    () => [
      {
        title: "Prayer meeting with us at the salvation studio",
        text: "",
        bgImage: "/images/image_9.png",
        color: "#4A4A4A",
      },
      {
        title: "Top 10 naija hit",
        text: "Listen to naija hit live with...",
        bgImage: "/images/image_1.png",
        color: "#C4CBDB",
      },
      {
        title: "The Hour of Mercy",
        text: "Listen to naija hit live with...",
        bgImage: "/images/image_11.png",
        color: "#98081C",
      },
      {
        title: "Prayer meeting with us at the salvation studio",
        text: "",
        bgImage: "/images/image_12.png",
        color: "#4A4A4A",
      },
      {
        title: "Top 10 naija hit",
        text: "Listen to naija hit live with...",
        bgImage: "/images/image_13.png",
        color: "#C4CBDB",
      },
      {
        title: "The Hour of Mercy",
        text: "Listen to naija hit live with...",
        bgImage: "/images/image_14.png",
        color: "#98081C",
      },
      {
        title: "Prayer meeting with us at the salvation studio",
        text: "",
        bgImage: "/images/image_7.png",
        color: "#4A4A4A",
      },
    ],
    []
  );

  useEffect(() => {
    dispatch(fetchUsers());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchOngoingEvents({ page: ongoingPage, pageSize: PAGE_SIZE }));
  }, [dispatch, ongoingPage]);

  useEffect(() => {
    dispatch(fetchUpcomingEvents({ page: upcomingPage, pageSize: PAGE_SIZE }));
  }, [dispatch, upcomingPage]);

  const handleOngoingPrev = () => {
    setOngoingPage((prev) => Math.max(1, prev - 1));
  };

  const handleOngoingNext = () => {
    if (liveEvents.length < PAGE_SIZE) {
      return;
    }
    setOngoingPage((prev) => prev + 1);
  };

  const handleUpcomingPrev = () => {
    setUpcomingPage((prev) => Math.max(1, prev - 1));
  };

  const handleUpcomingNext = () => {
    if (upcomingEventCards.length < PAGE_SIZE) {
      return;
    }
    setUpcomingPage((prev) => prev + 1);
  };

  const handleFilterdrop = () => {
    setFilterdrop((prev) => !prev);
  };

  const handleShowAccess = () => {
    setShowAccess(!showAcess);
  };
  const handlePopSchedule = () => {
    setShowPopSchedule(!showPopSchedule);
  };
  const handleLinkClick = (link) => {
    setActiveLink(link);
  };

  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
  };
  const handleSelectAccess = (access) => {
    setSelectedAccess(access); // Update the selected category
    setShowAccess(false); // Close the dropdown
  };
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setUploadedImage(e.target.result); // Set the uploaded image
      };
      reader.readAsDataURL(file);
    }
  };
  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      setFileName(file.name);
      if (file.type === "video/mp4") {
        setUploadState("uploading");

        // Simulate file upload process
        setTimeout(() => {
          setUploadState("success");
        }, 2000);
      } else {
        setUploadState("error");
      }
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];

    if (file) {
      setFileName(file.name);
      if (file.type === "video/mp4") {
        setUploadState("uploading");

        // Simulate file upload process
        setTimeout(() => {
          setUploadState("success");
        }, 2000);
      } else {
        setUploadState("error");
      }
    }
  };

 

  const handleGoToListeningLive = (event) => {
    const targetChannel = event?.channelId;
    const targetEventId = event?.id;

    if (!targetChannel || !targetEventId) {
      toast.error("Streaming details are unavailable for this event.");
      return;
    }

    navigate(`/live/listening/${targetChannel}/${targetEventId}`);
  };

  const handleGoToCreator = () => {
    navigate("/users/dashboard")
  }

   const handleGoToDetails = (id) => {
    navigate(`/listener/eventsdetails/${id}`);
  };
  return (
    <EventRap>
      <div className="events-1">
        <div className="events-sub-1">
          <h4>Tune In to Your Favorites</h4>
          <p>Discover, Stream, and Enjoy the Ultimate listening Experience</p>
        </div>
        <button onClick={handleGoToCreator}>
          + Creator
        </button>
      </div>
      <div className="events-2">
        <div className="link-sub-event">
          <div className="link-container">
            <Link
              className={`link ${activeLink === "public" ? "active" : ""}`}
              onClick={() => handleLinkClick("public")}
            >
              Live now
            </Link>
            <Link
              className={`link ${activeLink === "upcoming" ? "active" : ""}`}
              onClick={() => handleLinkClick("upcoming")}
            >
              Upcoming
            </Link>
            <Link
              className={`link ${activeLink === "only" ? "active" : ""}`}
              onClick={() => handleLinkClick("only")}
            >
              Following
            </Link>
          </div>
          <div className="event-sub-2">
            <div className="search-div-input">
              <input type="text" placeholder="Search" />
              <Icon
                className="search-icon"
                icon="material-symbols:search"
                width="16"
                height="16"
                style={{ color: "#363d4f", cursor: "pointer" }}
              />
            </div>

            <div style={{
                position: "relative"
            }}>
            <div onClick={handleFilterdrop} className="filter-div">
            <img src="/images/filter-lines.svg" alt="" />

              <p>Filter</p>
            </div>
            {filterdrop? (
            <div className="filter-drop-down">
                <p>Radio/Broadcast</p>
                <p>Religion </p>
                <p>Sport</p>
                <p>Technology</p>
                <p>Health</p>
                <p>Politics</p>
            </div>
            ): ""}
            </div>
          </div>
        </div>
        {activeLink === "public" && (
          <div className="events-divs-grid">
            {ongoingEventsLoading ? (
              <div style={{ gridColumn: "1 / -1", display: "flex", justifyContent: "center", padding: "40px 0" }}>
                <ClipLoader size={40} color="#ED1C24" />
              </div>
            ) : liveEvents.length === 0 ? (
              <div style={{ gridColumn: "1 / -1", textAlign: "center", color: "#818893", padding: "40px 0" }}>
                No live events at the moment. Check back soon!
              </div>
            ) : (
              liveEvents.map((event, index) => (
              <div  onClick={() => handleGoToDetails(event.id)}
                className="events-text-divs "
                key={index}
                style={{
                  background: `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 20.95%, rgba(0, 0, 0, 0.659617) 81.51%, #000000 103.25%), url('${event.bgImage}')`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              >
                <div
                  style={{
                    height: "100%",
                  }}
                >
                  <div  className="the-play-audion-icon">
                    <img src="/images/audio_icon.png" alt="" />
                  </div>
                  <div className="push-down-event">
                    <div className="down-event-text-div">
                      <div
                        className="event-round"
                        style={{
                          background: `${event.color}`,
                        }}
                      ></div>
                      <div className="down-event-text">
                        <h4>{event.title}</h4>
                        <p>{event.text}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))) }
          </div>
        )}

        {activeLink === "public" && !ongoingEventsLoading && liveEvents.length > 0 && (
          <div className="pagination-controls">
            <button onClick={handleOngoingPrev} disabled={ongoingPage === 1}>
              Previous
            </button>
            <span>Page {ongoingPage}</span>
            <button
              onClick={handleOngoingNext}
              disabled={liveEvents.length < PAGE_SIZE}
            >
              Next
            </button>
          </div>
        )}

        {activeLink === "upcoming" && (
          <div className="events-divs-grid">
            {loading ? (
              <div style={{ gridColumn: "1 / -1", display: "flex", justifyContent: "center", padding: "40px 0" }}>
                <ClipLoader size={40} color="#ED1C24" />
              </div>
            ) : upcomingEventCards.length === 0 ? (
              <div style={{ gridColumn: "1 / -1", textAlign: "center", color: "#818893", padding: "40px 0" }}>
                No upcoming events scheduled right now.
              </div>
            ) : (
              upcomingEventCards.map((event, index) => (
                <div
                  className="events-text-divs "
                  key={index}
                  style={{
                    background: `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 20.95%, rgba(0, 0, 0, 0.659617) 81.51%, #000000 103.25%), url('${event.bgImage}')`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                    }}
                  >
                    <div  className="the-play-audion-icon">
                      <img src="/images/audio_icon.png" alt="" />
                    </div>
                    <div className="push-down-event">
                      <div className="down-event-text-div">
                        <div
                          className="event-round"
                          style={{
                            background: `${event.color}`,
                          }}
                        ></div>
                        <div className="down-event-text">
                          <h4>{event.title}</h4>
                          <p>{event.text}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        )}
        {activeLink === "upcoming" && !loading && upcomingEventCards.length > 0 && (
          <div className="pagination-controls">
            <button onClick={handleUpcomingPrev} disabled={upcomingPage === 1}>
              Previous
            </button>
            <span>Page {upcomingPage}</span>
            <button
              onClick={handleUpcomingNext}
              disabled={upcomingEventCards.length < PAGE_SIZE}
            >
              Next
            </button>
          </div>
        )}

        {activeLink === "only" && (
          <div className="events-divs-grid">
            {following.map((event, index) => (
              <div
                className="events-text-divs "
                key={index}
                style={{
                  background: `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 20.95%, rgba(0, 0, 0, 0.659617) 81.51%, #000000 103.25%), url('${event.bgImage}')`,
                  backgroundSize: "cover",
                  backgroundPosition: "cover",
                }}
              >
                <div
                  style={{
                    height: "100%",
                  }}
                >
                  <div className="the-play-audion-icon">
                    <img src="/images/audio_icon.png" alt="" />
                  </div>
                  <div className="push-down-event">
                    <div className="down-event-text-div">
                      <div
                        className="event-round"
                        style={{
                          background: `${event.color}`,
                        }}
                      ></div>
                      <div className="down-event-text">
                        <h4>{event.title}</h4>
                        <p>{event.text}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <div>
        {showPopSchedule ? (
          <div className="dropdown-container">
            <div className="all-dropdown-div">
              <div className="dropdown-header">
                <h4>Upload recordings</h4>
                <Icon
                  onClick={handlePopSchedule}
                  icon="mdi:times"
                  width="16"
                  height="16"
                  style={{ color: "#828286", cursor: "pointer" }}
                />
              </div>
              <div className="dropdown-div">
                <div>
                  <input type="text" placeholder="Recording title" />
                </div>
                <div
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                  className="recording-upload-dic"
                >
                  {uploadState === "default" && (
                    <>
                      <input
                        type="file"
                        accept=".mp4"
                        onChange={handleFileUpload}
                        style={{ display: "none" }}
                        id="file-upload"
                      />
                      <label
                        htmlFor="file-upload"
                        style={{ cursor: "pointer" }}
                        className="the-upload-input"
                      >
                        <div className="audio-icon-div">
                          <img src="/images/audio-icon.png" alt="audio wave" />
                        </div>
                        <p className="click-upload">
                          <span>Click to upload </span>
                          or drag and drop
                        </p>

                        <p className="click-upload">
                          MP4 only (max size: 800x400px)
                        </p>
                      </label>
                    </>
                  )}

                  {uploadState === "uploading" && (
                    <div>
                      <div className="audio-icon-div">
                        <img src="/images/audio-icon.png" alt="audio wave" />
                      </div>
                      <p>{fileName}</p>
                      <p>200 KB - 100% uploading</p>
                    </div>
                  )}

                  {uploadState === "success" && (
                    <div>
                      <p>File uploaded successfully!</p>
                      <p>{fileName}</p>
                    </div>
                  )}

                  {uploadState === "error" && (
                    <div>
                      <div className="audio-icon-div">
                        <img src="/images/audio-icon.png" alt="audio wave" />
                      </div>
                      <p style={{ color: "red" }}>
                        Upload failed, please{" "}
                        <span style={{ textDecoration: "underline" }}>
                          Try again
                        </span>
                      </p>
                      <p>{fileName}</p>
                    </div>
                  )}
                </div>
                <div className="category">
                  <div onClick={handleShowAccess} className="category-input">
                    <p>{selectedAccess}</p>{" "}
                    {/* Display the selected category */}
                  </div>
                  {showAcess && (
                    <div className="category-dropdown">
                      <p onClick={() => handleSelectAccess("Public")}>Public</p>
                      <p onClick={() => handleSelectAccess("Only me")}>
                        Only me
                      </p>
                      <p onClick={() => handleSelectAccess("Unlisted")}>
                        Unlisted
                      </p>
                    </div>
                  )}
                </div>
                <div>
                  <input
                    className="schedules-inp"
                    style={{
                      height: "120px",
                      borderRadius: "15px",
                      textAlign: "start",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                    }}
                    type="text"
                    placeholder="Event Description"
                  />
                </div>
                <div className="add-uploaded-divs">
                  <div>
                    <label className="custom-radio">
                      <input
                        type="radio"
                        value="default"
                        checked={selectedOption === "default"}
                        onChange={handleRadioChange}
                      />
                      <span className="radio-checkmark"></span>
                      Use default theme
                    </label>

                    <label className="custom-radio">
                      <input
                        type="radio"
                        value="upload"
                        checked={selectedOption === "upload"}
                        onChange={handleRadioChange}
                      />
                      <span className="radio-checkmark"></span>
                      Upload image
                    </label>
                  </div>

                  {selectedOption === "default" && (
                    <div>
                      <img
                        className="uploadedImage-default"
                        src="/images/image_1.png" // Replace with your default image URL
                        alt="Default Theme"
                        style={{
                          width: "300px",
                          height: "150px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>
                  )}

                  {selectedOption === "upload" && (
                    <div>
                      {!uploadedImage ? (
                        <div className="uploadedImage">
                          <div className="file-upload">
                            <label className="upload-img-div">
                              Choose Image
                              <input
                                onChange={handleImageUpload}
                                type="file"
                                accept="image/*"
                                className="fileInput"
                              />
                            </label>
                          </div>
                          <p>
                            JPG or PNG accepted, Max size 10mb. (Default size:
                            1400x800)
                          </p>
                        </div>
                      ) : (
                        <img
                          className="uploadedImage-default"
                          src={uploadedImage}
                          alt="Uploaded"
                          style={{
                            width: "300px",
                            height: "150px",
                            border: "1px solid #ccc",
                          }}
                        />
                      )}
                    </div>
                  )}
                </div>
                <button className="schedule-btn">Schedule event</button>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </EventRap>
  );
};

export default ListenerEvents;
